import axiosInstance from './axiosInstance';
const API_URL = process.env.REACT_APP_API_URL;

export const getIndustries = async () => {
  const resp = await axiosInstance.get(`${API_URL}/industry`);
  return resp.data;
};

export const createIndustry = async (data) => {
  const resp = await axiosInstance.post(`${API_URL}/industry`, data);
  return resp.data;
};

export const updateIndustry = async (id, data) => {
  const resp = await axiosInstance.put(`${API_URL}/industry/${id}`, data);
  return resp.data;
};

export const deleteIndustry = async (id) => {
  const resp = await axiosInstance.delete(`${API_URL}/industry/${id}`);
  return resp.data;
};
